import { IntlProvider as Provider } from 'react-intl';
import { en, fr } from '@algoan/dashboard/lang';
import { Language } from '@algoan/dashboard/model';
import { useLanguage } from '@algoan/dashboard/utils';
import { FC, ReactNode } from 'react';
import { useSelector } from '@algoan/dashboard/store/store';
import { currencySelector } from '@algoan/dashboard/store/selectors';

const selectMessages = (language: Language): typeof en | typeof fr => (language === Language.EN ? en : fr);

export const IntlProvider: FC<{ children: ReactNode }> = ({ ...props }) => {
  const { language } = useLanguage();
  const messages = selectMessages(language);
  const currency = useSelector(currencySelector);

  const languageWithoutCountry = language.split('_')[0];

  const locale = languageWithoutCountry === Language.EN || currency === 'GBP' ? 'en-GB' : languageWithoutCountry;

  return <Provider locale={locale} messages={messages} wrapRichTextChunksInFragment={true} {...props} />;
};
